import { render, staticRenderFns } from "./InboundCompleteModal.vue?vue&type=template&id=886e1c32"
import script from "./InboundCompleteModal.vue?vue&type=script&lang=js"
export * from "./InboundCompleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports